<template>
    <div class="middleBox">
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="row justify-content-center" v-if="div_show == ''">
            <div class="col-12">
                <div class="twofa_activate mt-5 mb-5 d-flex align-items-center justify-content-between border p-4">
                    <div class="title">
                        <h3> {{$t('faText')}}</h3>
                        <span class="activate" v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1"> {{$t('alreadyEnabled')}}</span>
                        <span class="notactivate" v-else> {{$t('setUp2FA')}}</span>
                    </div>
                    <div class="enable">
                        <a href="#" class="btn_xs grd_btn grd_red"  @click="enable_disable_func('2')" v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1"> {{$t('clickToDisable')}}</a>
                        <a href="#" class="btn_xs grd_btn" @click="enable_disable_func('1')" v-else> {{$t('clickToEnable')}}</a>
                    </div>
                </div>  
           </div>  
       </div>
       <div class="row justify-content-center" v-if="div_show == '1'">
           <div class="col-12"> 
                <div class="authSteps box-shadow border p-0">
                    <div class="head p-3 border-bottom">
                        <h3> {{$t('enable2FaText')}}</h3>
                        <small> {{$t('accounntSafe3Steps')}}</small>
                    </div>
                    <div class="twoauthSteps py-3"> 
                        <div class="d-flex align-items-center border-bottom py-2 mb-2">
                            <div class="ico  mr-3">
                                <img src="../../../../static/fxView/images/google_auth.png" alt="Authenticator APP">
                            </div>
                            <div class="desc text-left">
                                <h5> {{$t('downloaduthApp')}}</h5>
                                <p> {{$t('downloaduthAppText')}}</p>
                            </div>
                        </div>
                        <div class="d-flex align-items-center border-bottom py-2 mb-2">
                            <div class="ico  mr-3">
                               <img :src="src_data" >
                            </div>
                            <div class="desc text-left">
                                <h5> {{$t('scanQrCode')}}</h5>
                                <p class="mb-3">{{$t('scanQrCodeText')}}</p> 
                               
                            </div>
                        </div>
                        <div class="d-flex align-items-center py-2">
                            <div class="ico mr-3">
                                <img src="../../../../static/fxView/images/2FA_OTP.svg" alt="Authenticator OTP">
                            </div>
                            <div class="desc text-left">
                                <h5> {{$t('loginYourCode')}}</h5>
                                <p class="mb-3"> {{$t('enter6DigitCode')}}</p>
                                <div class="authenticator_input d-flex align-items-center">
                                    <input type="text" v-model="otp" v-validate="'required'" name="6 Digit Verification Code" class="form-control" placeholder="000 000"  :class="{ 'is-invalid': submitted && errors.has('6 Digit Verification Code') }" ref="otpInput"> 
                                    <button class="prism_btn ml-3 btn_sm" v-on:click="verifyQrCode()"> {{$t('activate')}}</button>
                                </div>  
                                <p class="error" v-for="error in errors.collect('6 Digit Verification Code')">{{error}}</p>
                            </div>
                        </div> 
                    </div>
                </div>
           </div>  
       </div>
       <div class="row justify-content-center" v-if="div_show == '2'">
           <div class="col-12" >
                <div class="authSteps box-shadow border p-0">
                    <div class="head p-3 border-bottom">
                        <h3> {{$t('enterOtpDisableQrCode')}}</h3>
                    </div>
                    <div class="twoauthSteps py-3"> 
                        <div class="d-flex align-items-center py-3">
                            <div class="ico  mr-3">
                                <img src="../../../../static/fxView/images/2FA_OTP.svg" alt="Authenticator OTP">
                            </div>
                            <div class="desc text-left">
                                <h5> {{$t('disableCodeText')}}</h5>
                                <p class="mb-3"> {{$t('enter6DigitCode')}}</p>
                                <div class="authenticator_input d-flex align-items-center">
                                    <input type="text" v-model="DisableOtp" v-validate="'required'" name="Disable OTP" class="form-control"  :class="{ 'is-invalid': submit && errors.has('Disable OTP') }" ref="DisableOtpInput" placeholder="000 000">
                                    <button class="prism_btn ml-3 btn_sm" v-on:click="disableQrCode()"> {{$t('disable')}}</button>
                                </div> 
                            </div>
                        </div> 
                    </div> 
                </div> 
            </div> 
        </div>
    </div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'two-FA',
        mixins: [fxViewMixins],
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                src_data : '',
                otp : '',
                DisableOtp : '',
                submitted : false,
                submit : false,
                disableFieldShow : false,
                div_show : '',
                pageLoader : false,
            }
        },
        props:['call_from'],
        methods:{
            ...mapActions({
                _runGenerate2FaQrcode: types.RUN_GENERATE_2FA_QRCODE,
                _runVerify2FaQrcode: types.RUN_VERIFY_2FA_QRCODE,
                _runDisable2FaQrcode: types.RUN_DISABLE_2FA_QRCODE
            }),
            enable_disable_func(getData){
                this.div_show = getData
            },
            disableQrCode(){
                const _that = this
                _that.submit = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.DisableOtp.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runDisable2FaQrcode(input_json)
                    }
                })
            },
            generateQrCode(){
                let input_json={
                    'globalParams' :{
                        
                    },
                    'localParams' :{ "parameter" : this }
                }
                this._runGenerate2FaQrcode(input_json)
            },
            verifyQrCode(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString()
                            },
                            'localParams' :{ "parameter" : _that , 'call_from' : _that.call_from}
                        }
                        _that._runVerify2FaQrcode(input_json)
                    }
                })
            }
        },
        created(){
            if(parseInt(this.get_user.profile.gAuthenticatorEnabled) == 0){
                this.generateQrCode()
            }
			if(this.call_from != '' && this.call_from != null){
				this.enable_disable_func('1')
			}
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/2FA.vue